import mensajeError from "../../mensajes/MensajeError";
import { mensajeExitoso } from "../../mensajes/MensajeExitoso";
import obtenerContribuyente from "../contribuyente/obtenerContribuyente";

export default async function crearDireccion (dataDireccion, data, setData, idContribuyente) {
    dataDireccion.idContribuyente = idContribuyente;
    dataDireccion.calle = dataDireccion.calle ?? "";
    dataDireccion.numeroExterior = dataDireccion.numeroExterior ?? "";
    dataDireccion.numeroInterior = dataDireccion.numeroInterior ?? "";
    dataDireccion.colonia = dataDireccion.colonia ?? "";
    dataDireccion.codigoPostal = dataDireccion.codigoPostal ?? "";
    dataDireccion.idEstado = dataDireccion.idEstado ?? 13;
    dataDireccion.idMunicipio = dataDireccion.idMunicipio ?? (dataDireccion.idEstado === 13 ? 1 : 1);
    dataDireccion.idLocalidad = dataDireccion.idLocalidad ?? (dataDireccion.idEstado === 13 ? 25 : 25);
    dataDireccion.esFiscal = dataDireccion.esFiscal ?? 0;
    dataDireccion.cruceCalles = dataDireccion.cruceCalles ?? "";
    dataDireccion.referencia = dataDireccion.referencia ?? "";
    dataDireccion.telefono = dataDireccion.telefono ?? "";
    dataDireccion.fax = "";
    dataDireccion.telefonoEsParticular = 0;

    const settings = {
        method: "POST",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json",
        },
        body: JSON.stringify(dataDireccion)
    };

    try {
        const dataResponse = await (await fetch("/api/direccion/crear", settings)).json();
        if (dataResponse.status === "Ok") {
            setData({ ...data, direcciones: [{ ...dataResponse.data }] });
            mensajeExitoso("Contribuyente creado");
            obtenerContribuyente(idContribuyente, setData);
        }
        else mensajeError("Fue imposible crear una dirección");
    } catch (err) {
        console.log(err)
        mensajeError("Error: ", err.message)
    }
}